import { render, staticRenderFns } from "./vInsert.vue?vue&type=template&id=b4bba876&scoped=true&"
import script from "./vInsert.vue?vue&type=script&lang=js&"
export * from "./vInsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bba876",
  null
  
)

export default component.exports